import React, { Fragment } from "react";
import "./Display.css";
import Fade from 'react-reveal/Fade';
import Iframe from 'react-iframe';
import MapImg from '../../assets/Home/Map.svg'
import { Dimensions } from "../../Helper/sitedimension";

const Display = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    <Fragment>
      {width > 500 ?
        <div className="display">
          <div className="container-fluid bg-1" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
            <div className="main">
              <span className="content"><Fade delay={300} top>Data Breach </Fade> </span>
            </div>
            <div className="content1">
              <h5>
                <Fade delay={600}>
                Stay safe from the global data breach scenario. Get in touch with us for a secure shield architecture for your Web Apps
            </Fade>
              </h5>
            </div>
            <Fade delay={800}>
              <div style={{ position: "relative", top: "3%" }}>
                <img className="map" src={MapImg} />
              </div>
            </Fade>
          </div>
        </div> :
        <div className="displayhome">
          <div className="container-fluid bg-1" style={{ paddingLeft: "0px", paddingRight: "0px" }}>
            <div className="mainhome">
              <span className="content"><Fade delay={300} top>Data Breach </Fade> </span>
            </div>
            <div className="content1home">
              <h6>
                <Fade delay={600}>
                Stay safe from the global data breach scenario. Get in touch with us for a secure shield architecture for your Web Apps
          </Fade>
              </h6>
            </div>
            <Fade delay={800}>
              <div style={{ position: "relative", top: "3%" }}>
                <img className="maphome" src={MapImg} />
              </div>
            </Fade>
          </div>
        </div>
      }
    </Fragment>

  );
};

export default Display;
